import editForm from 'formiojs/components/content/Content.form';

export default function(...extend) {
    return editForm([
        {
            key: 'display',
            components: [
                {"html":"<p>Instruction Content will only be shown to users while editing the form. When the filled-out form is shown to other users, this content will not be included.</p>","label":"Content","refreshOnChange":false,"key":"content","type":"content","input":false,"tableView":false}
            ]
        }], ...extend);
}
